import React from 'react'
import imageLogo from '../images/image-logo.png'
import imageHero from '../images/image-hero.jpg'

const GlobalError = (): JSX.Element => {
  return (
    <div
      className="mx-auto overflow-hidden w-full max-w-[1200px] text-king-blue min-h-[440px] md:min-h-[450px] md:pt-[70px] pt-10"
      style={{
        backgroundImage: `url(${imageHero})`,
        backgroundSize: 'cover',
      }}
    >
      <div className="bg-king-red-900 w-full md:w-[70%] md:p-10 p-5 text-white text-lg md:text-xl leading-7 font-extralight animate-[slideInFromLeft_1s_ease-out_0.2s_forwards] opacity-0">
        <a
          href="https://kingenergy.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <img
            src={imageLogo}
            alt="King Energy Logo"
            className="w-[200px] md:w-[150px]"
          />
        </a>
        <div>
          <h1 className="font-extralight text-3xl text-white my-10 mb-5">
            Invitation invalid
          </h1>
          <div>
            This link contains an invitation code that is invalid, expired, or
            previously consumed. Please ensure that you have the correct link
            and try again. If you feel you have received this message in error,
            please reach out to us.
          </div>
          <div className="mt-5">
            <p className="my-1">
              Phone: <a href="tel:8007811765" className="underline text-white hover:text-white">(800) 781-1765</a>
            </p>
            <p className="my-1">
              Email:{' '}
              <a href="mailto:support@kingenergy.com" className="underline text-white hover:text-white">
                support@kingenergy.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-b from-transparent to-white h-[120px] md:h-[50px] w-full" />
    </div>
  )
}

export default GlobalError
